import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AzavistaButtonModule } from '@azavista/components/button';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import { EntityUpdatedTriggerDialogComponent } from './entity-updated-trigger-dialog/entity-updated-trigger.component';
import { ActivityParticipantStatusChangedTriggerComponent } from './activity-participant-status-changed-trigger-dialog/activity-participant-status-changed-trigger.component';
import { SharedModule } from '../shared';
import { StopProcessDialogComponent } from './stop-process-dialog/stop-process-dialog.component';

@NgModule({
    declarations: [
        EntityUpdatedTriggerDialogComponent,
        ActivityParticipantStatusChangedTriggerComponent,
        StopProcessDialogComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        AzavistaButtonModule,
        AzavistaInputFieldModule,
        SharedModule,
    ],
})
export class ProcessesSharedModule { }
